export default {
  UnivLogos: [
    {
      url: 'https://www.nwmissouri.edu/career/students/index.htm',
      imageUrl:
        'https://gatsby.wisedoc.net/northwest-missouri-state-university.png',
    },
    {
      url: 'https://business.oregonstate.edu/',
      imageUrl: 'https://gatsby.wisedoc.net/oregon-state-university.png',
    },
    {
      url: 'https://www.cco.purdue.edu/',
      imageUrl: 'https://gatsby.wisedoc.net/homepage/Purdue_Logo.png',
    },
    {
      url: 'https://www.sagehillschool.org/',
      imageUrl: 'https://gatsby.wisedoc.net/sage+hill.png',
    },
    {
      url: 'https://www.ewu.edu/',
      imageUrl: 'https://gatsby.wisedoc.net/EWU.png',
    },
    {
      url: 'https://vcea.wsu.edu/student-success/2024/01/08/crafting-your-career-story-a-quick-guide-to-resume-building-with-wisedoc/',
      imageUrl: 'https://gatsby.wisedoc.net/homepage/WSU_Logo.png',
    },
    {
      url: 'https://www.apsu.edu/',
      imageUrl: 'https://gatsby.wisedoc.net/homepage/APSU_Logo.png',
    },
    {
      url: 'https://wou.edu/professional-pathways/',
      imageUrl: 'https://gatsby.wisedoc.net/homepage/WOU_Logo.png',
    },
    {
      url: 'https://fororegonstate.org/get-involved/osu-alumni-career-services/career-support',
      imageUrl: 'https://gatsby.wisedoc.net/homepage/OSU_Alum_Logo.png',
    },
    {
      url: 'https://www.kennesaw.edu/coles/degrees-programs/undergraduate/career-services.php',
      imageUrl: 'https://gatsby.wisedoc.net/homepage/KSU_Logo.png',
    },
  ],
};
